import dayjs from "@eisox/dayjs";
import { loadLocale } from "@eisox/zod";

import { getLocale } from "~/paraglide/runtime";

const initLanguage = async (language: string) => {
  const lng = ["fr", "en"].includes(language) ? (language as "fr" | "en") : "fr";
  await loadLocale(lng);
  dayjs.locale(lng);
};

const initLanguageFromParaglide = () => initLanguage(getLocale());

export { initLanguage, initLanguageFromParaglide };
